import { render, staticRenderFns } from "./AreaProdutiva2007Ap.vue?vue&type=template&id=4fb4e33e&lang=pug"
import script from "./AreaProdutiva2007Ap.vue?vue&type=script&lang=js"
export * from "./AreaProdutiva2007Ap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports